const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Teams settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('teamsSettings', ['Application', 'CompanyIntegrations', function (Application, CompanyIntegrations) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/teams-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.tenantAuthLink = Application.teamsAppTenantAuthLink;
      self.version = Application.microsoftTeamsVersion;
      self.initialize = function () {
        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasTeams = !!(data.microsoftTeamsMessaging?.version) || false;
          self.needsUpdate = data.microsoftTeamsMessaging.version !== self.version;
          self.delegatedAuthLink = Application.teamsAppDelegatedAuthLink + `&state=${data.microsoftTeamsMessaging.tenant_id}`
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });

      };
      self.initialize();
    }],
    controllerAs: 'teams'
  };
}]);
